<template>
  <v-app id="login" class="primary">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/static/logo/fg-logo.svg"
                    alt="FG Payment"
                    width="120"
                    height="120"
                  />
                  <h2 class="flex my-4 primary--text">
                    {{ $t("resetPassword.title") }}
                  </h2>
                </div>
                <v-form name="loginForm" ref="loginForm" :model="loginForm">
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    :label="$t('common.password')"
                    id="password"
                    type="password"
                    v-model="loginForm.password"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="passwordConfirmation"
                    :label="$t('common.passwordConfirmation')"
                    id="passwordConfirmation"
                    type="password"
                    v-model="loginForm.passwordConfirmation"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <router-link to="login">{{
                  $t("forgotPassword.goBackLogin")
                }}</router-link>
                <v-spacer></v-spacer>
                <v-btn width="200" color="primary" @click="login" :loading="loading"
                  >{{ $t("resetPassword.resetButton") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-snackbar
            :timeout="3000"
            :bottom="snackbar.y === 'bottom'"
            :top="snackbar.y === 'top'"
            :multi-line="snackbar.mode === 'multi-line'"
            right
            :color="snackbar.color"
            v-model="snackbar.show"
          >
            {{ snackbar.text }}
            <v-btn dark text @click.native="snackbar.show = false" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { setToken } from "@/util/auth";

export default {
  name: "ResetPassword",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("The password can not be less than 6 digits"));
      } else {
        callback();
      }
    };
    return {
      checkbox: false,
      loading: false,
      loginForm: {
        token: "",
        password: "",
        passwordConfirmation: ""
      },
      loginRules: {
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
        passwordConfirmation: [
          { required: true, trigger: "blur", validator: validatePassword }
        ]
      },
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  methods: {
    login() {
      this.loading = true;

      this.$store
        .dispatch("resetPassword", this.loginForm)
        .then(() => {
          this.loading = false;
          this.snackbar = {
            show: true,
            color: "green",
            text: "Your password is updated."
          };
          this.$refs.loginForm.reset();
          this.$router.push({ path: "/dashboard" });
        })
        .catch(error => {
          this.snackbar = {
            show: true,
            color: "red",
            text: error.response.data.errors.full_messages[0]
          };
          this.loading = false;
        });
    },
    autoLogin(route) {
      let token = {
        "access-token": route.query["access-token"],
        expiry: route.query["expiry"],
        "token-type": route.query["token-type"],
        uid: route.query["uid"],
        client: route.query["client"]
      };
      this.loginForm.token = route.query["token"];
      setToken(token);
    }
  },
  created() {
    let route = this.$route;
    if (route.query && route.query["access-token"]) {
      this.autoLogin(route);
    }
  }
};
</script>
<style scoped lang="css">
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}

.v-card__actions .v-btn {
    margin: 0;
    min-width: 56px;
}
</style>
